module.exports = __webpack_public_path__ + "static/media/sync-alt.cc21bb0a.svg";